module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservation"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "hidden-print"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n                    Create reservation\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-offset-2 col-md-8 col-md-offset-1 col-sm-12"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Room")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Room",
      "track-by": "label",
      "label": "label",
      "options": _vm.roomOptions,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selectedRoom),
      callback: function($$v) {
        _vm.selectedRoom = $$v
      },
      expression: "selectedRoom"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Type",
      "track-by": "label",
      "label": "label",
      "options": _vm.typeOptions,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.name),
      expression: "reservation.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.doubleBooking
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Arrival")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'YYYY-MM-DD'
      }
    },
    model: {
      value: (_vm.arrival),
      callback: function($$v) {
        _vm.arrival = $$v
      },
      expression: "arrival"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.doubleBooking
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Departure")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'YYYY-MM-DD'
      }
    },
    model: {
      value: (_vm.departure),
      callback: function($$v) {
        _vm.departure = $$v
      },
      expression: "departure"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Per night")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.pricePerNight),
      expression: "reservation.pricePerNight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.pricePerNight)
    },
    on: {
      "keyup": _vm.updatePriceTotal,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "pricePerNight", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Total")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.price),
      expression: "reservation.price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.price)
    },
    on: {
      "keyup": _vm.updatePriceNight,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "price", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Number of guests")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.guests),
      expression: "reservation.guests"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.guests)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "guests", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Breakfast")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Eating guests")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.numberOfBreakfasts),
      expression: "reservation.numberOfBreakfasts"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.numberOfBreakfasts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "numberOfBreakfasts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Total for all nights")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.totalPriceBreakfast),
      expression: "reservation.totalPriceBreakfast"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.totalPriceBreakfast)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "totalPriceBreakfast", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.comment),
      expression: "reservation.comment"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.reservation.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create reservation")])])])])])])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60043a7f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reservations/Create.vue
// module id = 396
// module chunks = 1